import { __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'

/**
 * Schema for taxonomy topics used to categorize and filter resources.
 * Topics come from the taxonomy service and are used for dynamic
 * resource discovery on index pages.
 */
export const TopicSchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  id: z.string(),
  preferred_label: z.string(),
  definition: z.string().optional(),
});
function __fc_1(input){var __w_0;return typeof input==="object"&&input!==null&&!Array.isArray(input)&&typeof input["id"]==="string"&&typeof input["preferred_label"]==="string"&&((__w_0=input["definition"])===undefined||(typeof __w_0==="string"));}
var __bf_2={};
function __vb_7(input){var __bv_3,__bv_4,__bv_5,__bo_6;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_3=input["id"];if(!(typeof __bv_3==="string"))return __bf_2;__bv_4=input["preferred_label"];if(!(typeof __bv_4==="string"))return __bf_2;__bv_5=input["definition"];if(!((__bv_5===undefined||(typeof __bv_5==="string"))))return __bf_2;__bo_6={"id":__bv_3,"preferred_label":__bv_4};if(__bv_5!==undefined||("definition" in input)){__bo_6["definition"]=__bv_5;}return __bo_6;}
var __rfm_z=__zs.safeParse;
function safeParse_TopicSchema(input){
var __bd_8=__vb_7(input);
if(__bd_8!==__bf_2){return{success:true,data:__bd_8};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_TopicSchema,__zs,null,__fc_1);
})()

export type Topic = z.infer<typeof TopicSchema>
